import React from 'react';
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useTranslation} from 'react-i18next';
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";

const ToRouteModeMutateSingleVoyage = () => {

    const {t} = useTranslation()

    const {
        points,
    } = useRootContextMutateSingleVoyage()

    const {
        setModeSecondarySidebar,
        modeSecondarySidebar,
        setMiniModeSecondarySidebar
    } = useViewContextMutateSingleVoyage()

    const toRouteMode = () => {
        setModeSecondarySidebar('route')
        if (modeSecondarySidebar) {
            setMiniModeSecondarySidebar(false)
        }
    }
    return (
        <PrimaryButtonSingleVoyage
            fullWidth
            onClick={toRouteMode}
            disabled={points?.length < 2}
        >
            {t('singleVoyage.settingsRoute')}
        </PrimaryButtonSingleVoyage>
    );
};

export default ToRouteModeMutateSingleVoyage;
